import { render, staticRenderFns } from "./ButtonCircle.vue?vue&type=template&id=49749bb6"
import script from "./ButtonCircle.vue?vue&type=script&lang=js"
export * from "./ButtonCircle.vue?vue&type=script&lang=js"
import style0 from "./ButtonCircle.vue?vue&type=style&index=0&id=49749bb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports